// btw-front/src/components/ui/Input.jsx
import React from "react";

export function Input({
  label,
  required = false,
  error,
  hint,
  className = "",
  inputClassName = "",
  id,
  ...rest
}) {
  const inputId = id || rest.name || undefined;
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && (
        <label htmlFor={inputId} className="text-xs font-medium text-slate-700">
          {label}
          {required && <span className="ml-0.5 text-rose-500">*</span>}
        </label>
      )}
      <input
        id={inputId}
        className={`rounded-lg border bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:ring-2 focus:ring-accent/30 ${
          error ? "border-rose-400 focus:border-rose-500" : "border-slate-300 focus:border-accent"
        } ${inputClassName}`}
        aria-invalid={!!error}
        {...rest}
      />
      {error ? (
        <p className="text-xs text-rose-600">{error}</p>
      ) : hint ? (
        <p className="text-xs text-slate-500">{hint}</p>
      ) : null}
    </div>
  );
}
